/**
 *
 * Notes: May, 2019
 * Original source code pulled (and edited) from previous website.
 * Assuming this was custom developed by previous vendor since license was not provided.
 *
 */

import $ from 'jquery';

export default ValueOfInvestment;

function ValueOfInvestment (o) {

    let $container = $(o),
        $form = null,
        $principal = null,
        $contributions = null,
        $interest = null,
        $term = null,
        $freq = null,
        $savings;


    function fva(PMT, ic, nc) {
        let v = Math.pow((1 + ic), nc);
        return (PMT * (v - 1) / ic);
    }


    function fv(P, i, n) {
        return (P * Math.pow((1 + i), n));
    }

    $form = $container.find("form");
    $principal = $form.find("input[name=principal]");
    $contributions = $form.find("input[name=contributions]");
    $interest = $form.find("input[name=interest]");
    $term = $form.find("input[name=term]");
    $freq = $form.find("input:radio[name=freq]");
    $savings = $form.find("input[name=savings]");

    //console.log($interest);

    $form.submit(function(e) {
        $form.find('.calc-results').removeClass('hidden');
        let P = Number($principal.val().replace("$", "")); // Starting principal (P)
        let r = Number($interest.val().replace("%", ""))/100; // Annual interest rate as decimal
        let t = Number($term.val()); // Number of years (t)
        let PMT = Number($contributions.val().replace("$", "")); // Contributions (PMT)
        let m = 365; // num compounding intervals in year
        let n = m * t; // Total number of compunding periods
        let i = r / m; //Interest rate per period (i)
        let mc = Number($freq.filter(":checked").val());// Number of contributions per year (mc)
        let nc = mc * t; //Total number of contributions periods (nc)

        let tot1 = fv(P, i, n);

        let ie = Math.pow((1 + (r / m)), m) - 1;
        let ic = ie / mc;

        let tot2 = fva(PMT, ic, nc);

        $savings.val((tot1 + tot2).toFixed(2));
        $savings.currency();

        e.preventDefault();
        return false;

    });


    $container.find("button[type='reset']").on('click',function(){
        $('.calc-results').addClass('hidden');
        $principal.focus();
    });

}


// WEBPACK FOOTER //
// ./src/calculators/value-of-investment.js